import type { QualityReportStatus, QualityReportUpload, ReportCategory } from "./types";

const REPORT_CATEGORIES: Array<{ category: ReportCategory; label: string }> = [
  { category: "meat", label: "肉类" },
  { category: "produce", label: "蔬菜水果" },
  { category: "dryGoods", label: "干杂调料" },
  { category: "staple", label: "米面油" }
];

export function buildReportStatuses(uploads: QualityReportUpload[], now = new Date()): QualityReportStatus[] {
  const todayKey = toLocalDateKey(now);

  return REPORT_CATEGORIES.map(({ category, label }) => {
    const todayUpload = uploads
      .filter((upload) => upload.category === category && toLocalDateKey(new Date(upload.uploadedAt)) === todayKey)
      .sort((left, right) => right.uploadedAt.localeCompare(left.uploadedAt))[0];

    return {
      category,
      label,
      updatedToday: Boolean(todayUpload),
      title: todayUpload?.title,
      uploadedAt: todayUpload?.uploadedAt,
      assetUrl: todayUpload?.assetUrl
    };
  });
}

export function toLocalDateKey(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
